import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isTokenExpired } from '../utils/tokenManagement';
import API_BASE_URL from '../utils/apiConfig';

const ProtectedRoute = ({ children }) => {
  const location = useLocation(); // This gives us the current attempted path
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const validateToken = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/auth/validateToken`, {
          method: 'GET',
          credentials: 'include', // Include credentials (cookies) in the request
        });

        if (response.ok) {
          const data = await response.json();
          setIsAuthenticated(true);
          const token = data.token; // Assuming the token is returned in the response
         } else {
            setIsAuthenticated(false);
        }  
      } catch (error) {
        console.error('Error validating token:', error);
        setIsAuthenticated(false);
      }
    };

    validateToken();
  }, []);

  if (isAuthenticated === null) {
    return <div>Loading...</div>; // Show a loading indicator while validating the token
  }

  return isAuthenticated ? (
    children
  ) : (
    <Navigate
      to="/createaccount"
      state={{ from: location }} // Save where the user was trying to go
      replace
    />
  );
};

export default ProtectedRoute;